<template>
  <div :class="$style.header">
    <div :class="$style.headerContainer">
      <div :class="$style.headerLogo"
           @click="handleLogoClick">
        <img src="@/assets/img/horizontal.png"
             alt="Burger Boss">
      </div>
      <div :class="$style.headerLogoMobile"
           @click="handleLogoClick">
        <img src="@/assets/img/white.png"
             alt="Burger Boss">
      </div>
      <div :class="$style.headerMenu">
        <DesktopUserData />
        <DesktopRestaurantButton />
        <DesktopCartIcon/>
      </div>
    </div>
  </div>
</template>

<script>
import { MODAL_UPDATE } from '@/apps/core/store/types';
import CommonModal from '@/apps/shared/components/CommonModal';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Action, Getter } from 'vuex-class';
import DesktopCartIcon from './DesktopCartIcon';
import DesktopRestaurantButton from './DesktopRestaurantButton';
import DesktopUserData from './DesktopUserData';

/**
 * Renders header component for desktop layout.
 */
@Component({
  name:       'DesktopHeader',
  components: {
    DesktopRestaurantButton,
    DesktopCartIcon,
    DesktopUserData,
    CommonModal,
  },
})
export default class DesktopHeader extends Vue {
  @Getter orderItemCompleted;
  @Action(MODAL_UPDATE) modalUpdate;

  handleLogoClick() {
    if (this.orderItemCompleted) {
      this.goToMenuOrMain();

      return;
    }

    this.modalUpdate({
      name: 'goToMenuOrMain',
      data: true,
    });
  }

  /**
   * Handle click on logo
   *
   * If the user has chosen the order type and restaurant, send it to the menu,
   * otherwise send it to the main page.
   */
  goToMenuOrMain() {
    this.modalUpdate({ name: 'goToMenuOrMain' });
    if (this.orderType !== null && this.restaurantId !== null) {
      this.$router.push({ name: 'menu' });

      return;
    }

    this.setOrderType(null);
    this.setRestaurantId(null);

    this.$router.push({ name: 'main' });
  }
}
</script>

<style lang="scss" module>
  @import "~@/style/variables.scss";
  .header {
    padding: 15px 0;
    background-color: $title-black;
    height: 70px;
    display: flex;
    align-items: center;
    width: 100%;
    z-index: 1;

    .headerContainer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 16px;
      padding-right: 23px;
      flex: 100%;
    }
  }

  .headerLogo {
    display: flex;
    max-width: 225px;
    cursor: pointer;
  }

  .headerLogoMobile {
    display: none;
    cursor: pointer;

    img {
      max-width: 100%;
      height: auto;
    }
  }

  .headerMenu {
    display: flex;
  }

  @media screen and (max-width: $mobile-breakpoint-max) {
    .header {
      padding: 8px 0;

      .headerContainer {
        padding-right: 16px;
      }
    }

    .headerLogo {
      display: none;
    }

    .headerLogoMobile {
      display: flex;
      align-items: center;
      max-width: 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/apps/desktop/components/DesktopHeader.vue